export default "__VITE_ASSET__5zYbdj2T__"